// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__KfrwA","inputWrap":"CustomTip_inputWrap__1E59d"};